import * as madnes from "../../framework/src/engine/madnes/madnes";
import {madnes_set_win_factors} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_default_volume} from "../../framework/src/engine/madnes/madnes_audio";
import {set_show_money_pos_y} from "../../framework/src/engine/madnes/madnes_anims";
import {he, wi} from "../../framework/src/engine/madnes/madnes_variables";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {joker27plus_end_round_recalced, joker27plus_rotate_run} from "../joker27plus_core";
import {joker27plus_print_desk} from "../joker27plus_reels";
import {joker27plus_print_reels} from "../joker27plus_core_printer";
import {
    joker27plus_infomenu_close,
    joker27plus_infomenu_init, joker27plus_infomenu_left,
    joker27plus_infomenu_open, joker27plus_infomenu_right, joker27plus_infomenu_update, openinfo
} from "../joker27plus_infomenu";
import {madnes_alpha_to, madnes_move_to} from "../../framework/src/engine/madnes/madnes_render";
import {madnes_set_pos_y} from "../../framework/src/engine/madnes/madnes_object";
import {joker27plus_fs_vibrate_end} from "../joker27plus_anims";
import {madnes_set_text} from "../../framework/src/engine/madnes/madnes_text";
import { main_phaser } from "../../framework/src/engine/madnes/MadnesApp";


export const infotexts_languages = [
    "cs", "en", "es", "fi", "hr", "no", "pl", "ro", "ru", "sr", "sv", "tr", "sk", "pt", "es-mx", "bg", "de", "fr", "it"
];

export function initGame(gameset) {

    set_show_money_pos_y(he * 0.46);

    madnes.set_ico_size(380, 194);

    madnes_set_win_factors(25, 50, 125);

    madnes_set_sprite("coins", 152, 152);

    madnes_set_sprite('blur', 330, 300);
    madnes_set_sprite('_sprite', 330, 300);
    //madnes_set_sprite('font_menu_Big', 40, 40);
    madnes_set_sprite('font_big-win', 134, 159);

    madnes_set_sprite('flares_sprite', 1280 / 4, 920 / 4);

    madnes_set_default_volume(0.8);

}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced(eventName, data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            infomenu_update();
            //soe_lines_close(data);
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function game_start() {
    main_phaser.tweens.frameBased = true;
    joker27plus_rotate_run()
}

export function print_desk() {
    joker27plus_print_desk()
}

export function print_reels() {
    joker27plus_print_reels();
}

export function infomenu_init() {
    joker27plus_infomenu_init();
}

export function infomenu_open() {
    joker27plus_infomenu_open();
}

export function infomenu_close() {
    joker27plus_infomenu_close();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    joker27plus_infomenu_left();
}

export function infomenu_right() {
    joker27plus_infomenu_right();
}

export function infomenu_update() {
    joker27plus_infomenu_update();
}

export function end_round_recalced(eventName, {autostart}) {
    joker27plus_end_round_recalced();

    if(!autostart) {
        end_round_no_autostart();
    }
}

export function end_round_no_autostart() {}

function freespins_end_round(eventName, {ended}) {}